module.exports = __webpack_public_path__ + "static/img/37.1ea45e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/37.png
// module id = NjVI
// module chunks = 0